import { useWindowSize } from 'hooks';
import { useEffect,useState } from 'react';
import { Button, Navbar } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import { Link, useHistory } from 'react-router-dom';
import { useStore } from 'store';
import { fetchFAQs } from 'store/actions/faqs';
// eslint-disable-next-line no-unused-vars
import { setLoginRedirect } from 'util/navigation';
import { setLoginRedirectSSO } from 'util/navigation';
import { isLogged } from 'services/commons'
import BarMobile from 'pages/Header/Content/components/BarMobile';  
import styles from './style.module.scss';

export const Question = ({ home }) => {

  const isLoggedIn = isLogged();
  const [, { isMobile }] = useWindowSize();
  const [listOfFAQs, dispatch] = useStore(({ faqs }) => faqs.listOfFAQs);
  const ListOfFAQsFull = listOfFAQs.results.list;
  const { params = {} } = listOfFAQs;
  const { totalPages } = listOfFAQs;
  const listOfQuestions = home
    ? ListOfFAQsFull.slice(0, isMobile ? 2 : 4)
    : ListOfFAQsFull;
  useEffect(() => {
    if (totalPages >= params.page) {
      dispatch(fetchFAQs({ incrementalList: false }));
    }
  }, [params.page]);

  const history = useHistory();
  const btnRegresar = () => history.goBack();
  const btnfaqs = () => history.push('/faqs');
  const btnReview = () => history.push('/review');

  const [respuestasVisibles, setRespuestasVisibles] = useState([]);

  const toggleRespuesta = (index) => {
    setRespuestasVisibles((prevRespuestasVisibles) => {
      const updatedRespuestasVisibles = [...prevRespuestasVisibles];
      updatedRespuestasVisibles[index] = !updatedRespuestasVisibles[index];
      return updatedRespuestasVisibles;
    });
  };

  const [activeAccordionIndex, setActiveAccordionIndex] = useState(null);

  const handleAccordionToggle = (index) => {
    setActiveAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const [newFAQS, setNewFAQS] = useState(false)
  useEffect(()=>{
    if(ListOfFAQsFull.length >= 1){
      const cat0 = ListOfFAQsFull.map(categoria => categoria.category)
      const cat1  = cat0.filter((valor, indice) => cat0.indexOf(valor) === indice )
      const categoria = cat1.map(catTotal => {
        const FAQSTotal =  {
          'category': catTotal,
          'faqs': ListOfFAQsFull.filter(faqs => faqs.category === catTotal)
        }
        return FAQSTotal
      })
      setNewFAQS(categoria)
    }
  },[ListOfFAQsFull])

  useEffect(()=>{
    if(newFAQS){
      // console.log('newFAQS: ',newFAQS)
    }
  },[newFAQS])

  return (
    <>
      {/* <section className={styles.HomeFAQ}>
        <div >
          <a className="link-button mb-3 d-inline-block" href={setLoginRedirect('crear-mesa', true, false, true)}>
            <Button block variant="primary">
              Crear mesa
            </Button>
          </a>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events
          <a className="link-button mb-2 d-inline-block" onClick={btnfaqs}>
            <Button block variant="secundary">
              Preguntas Frecuentes
            </Button>
          </a>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a className="link-button mb-2 d-inline-block" onClick={btnReview}>
            <Button block variant="secundary">
              Reseñas
            </Button>
          </a>
        </div>
         <div className="btn rojo" onClick={btnRegresar} ariaLabel="Regresar">Regresar</div>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div onClick={btnRegresar} ariaLabel="Regresar"> <strong>&#8592;</strong> Regresar</div>
        <div className="container">
          <div className="row">
            <div className="col">
              <p className={styles.title}>Preguntas Frecuentes</p>
            </div>
          </div>
          <div className="row m-1 text-justify">
            {/*<table>
            {listOfQuestions.map((question, key = 1) => (
              <tbody>
              <div key={key} className="styles.questionItem">
                <td><div className={styles.question_title} onClick={() => toggleRespuesta(key)}>
                  <p className="subtitle">{question.question}{respuestasVisibles[key] ? ' -' : ' +'}</p>
                </div>
                {respuestasVisibles[key] && (
                  <div
                    className={styles.text}
                    dangerouslySetInnerHTML={{ __html: question.answer }}
                  />
                )}</td>
              </div>
              </tbody>
            ))}
            </table>
            <Accordion>
              {listOfQuestions.map((question, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Card key={index}>
                    <Accordion.Toggle as={Card.Header} className={styles.cardheader} eventKey={index.toString()}>
                      {question.question}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={index.toString()}>
                      <Card.Body style={{ backgroundColor: '#e6e6e6' }}>
                        <div className="answer-content" dangerouslySetInnerHTML={{ __html: question.answer }} />
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
              ))}
            </Accordion>
          </div>
        </div>
        {home && (
          <div className="row d-flex justify-content-center mx-sm-2">
            <div className="col-xs-12 col-lg-4 align-self-center ">
              <Link className="link-button" to="/faqs">
                <Button size="lg" block variant="primary">
                  Ver más preguntas
                </Button>
              </Link>
            </div>
          </div>
        )}
      </section> */}

  <section className={styles.HomeFAQ}>
    <div className={styles['bar-desktop']}>
      <Navbar expand="lg">
        <Navbar.Brand>
          <a className="link-button d-inline-block primaryButton" href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
            <Button block variant="primary">
              Crear mesa
            </Button>
          </a>
        </Navbar.Brand>
        <Navbar.Brand>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events */}
          <a className="link-button d-inline-block secondaryButton" onClick={btnfaqs}>
            <Button block variant="secondary">
              Preguntas Frecuentes
            </Button>
          </a>
        </Navbar.Brand>
        <Navbar.Brand>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a className="link-button d-inline-block secondaryButton" onClick={btnReview}>
            <Button block variant="secondary">
              Reseñas
            </Button>
          </a>
        </Navbar.Brand>
      </Navbar>

      <div onClick={btnRegresar} ariaLabel="Regresar" className="btnRegresar" style={{  cursor: 'pointer', textAlign: 'left'}}>
        <strong>&#8592;</strong> Regresar
      </div>

    </div>

    <BarMobile
      pageName='Preguntas frecuentes'
      marginBottom={32}
    />
    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
    <div className="container">
      <div className="row">
        <div className="col">
          <p className={styles.title}>Preguntas Frecuentes</p>
        </div>
      </div>
      <div className="row m-1 text-justify">
        <div className={styles['questions-container']}>
          {newFAQS
            ?
              newFAQS.map((categoria, ind) => (
                  <div className="categoryFAQS" key={ind}>
                    <div className="titleCatFAQS">{categoria?.category}</div>
                    {categoria?.faqs
                      ?
                        <Accordion>
                          {categoria?.faqs.map((question, index) => (
                              <Card key={index}>
                                <Accordion.Toggle
                                    as={Card.Header}
                                    className={`${activeAccordionIndex === index && styles.cardheadertextred} ${styles.cardheader}`}
                                    eventKey={index.toString()}
                                    onClick={() => handleAccordionToggle(index)}
                                >
                                  <span className={styles.questionItem}>{question.question}</span>
                                  <i
                                      className={`fa fa-angle-down ${activeAccordionIndex === index && styles['icon-active']} ${styles.icon}`}
                                  />
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={index.toString()}>
                                  <Card.Body className = {styles.answer_container}>
                                    <div className={styles?.answer_content} dangerouslySetInnerHTML={{ __html: question.answer }} />
                                  </Card.Body>
                                </Accordion.Collapse>
                              </Card>
                          ))}
                        </Accordion>
                      : null
                    }
                  </div>
                )
              )
            : null
          }
          {/* <Accordion>
            {listOfQuestions.map((question, index) => (
                <Card key={index}>
                  <Accordion.Toggle
                      as={Card.Header}
                      className={`${activeAccordionIndex === index && styles.cardheadertextred} ${styles.cardheader}`}
                      eventKey={index.toString()}
                      onClick={() => handleAccordionToggle(index)}
                  >
                    <span className={styles.questionItem}>{question.question}</span>
                    <i
                        className={`fa fa-angle-down ${activeAccordionIndex === index && styles['icon-active']} ${styles.icon}`}
                    />
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={index.toString()}>
                    <Card.Body className = {styles['answer-container']}>
                      <div className="answer-content" dangerouslySetInnerHTML={{ __html: question.answer }} />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
            ))}
          </Accordion> */}
        </div>
      </div>
      {home && (
          <div className="row d-flex justify-content-center mx-sm-2">
            <div className="col-12 col-lg-4 align-self-center">
              <Link className="link-button" to="/faqs">
                <Button size="lg" block variant="primary">
                  Ver más preguntas
                </Button>
              </Link>
            </div>
          </div>
      )}
    </div>
  </section>
    </>
  );
};
